export default function collapseService() {
  return function generate(viewField, engineApi) {
    viewField.metadata = viewField.metadata || {};
    return engineApi.register
      .setCommonAttributes('ec-collapse', viewField, engineApi)
      .addAttribute('opened', viewField.metadata.open === true || viewField.metadata.open === 'true').setHtml(`
        <header>
          <ec-toolbar>
            <label>${viewField.title || ''}</label>
            <ec-space></ec-space>
            ${viewField.metadata.toolbar ? engineApi.handleProperties(viewField.metadata.toolbar, engineApi).reduce((acc, cur) => acc + cur.toString(), '') : ''}
          </ec-toolbar>
        </header>
        <main>
          <ec-flex-rows>
            ${engineApi.handleProperties(viewField, engineApi).reduce((acc, cur) => acc + cur.toString(), '')}
          </ec-flex-rows>
        </main>
      `);
  };
}
